import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerPsico'; 
import AboutPsicopedagogia from './AboutPsicopedagogia';
import Psicopedagogia from './CorpoClinicoPsicopedagogia';

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutPsicopedagogia />
        <Psicopedagogia />
      </div>
    );
  };
  
  export default About;
  